// extracted by mini-css-extract-plugin
export var dayLabel = "_k6-0";
export var pickerDisabled = "_k6-1";